<script>
export default {
	// todo
	// replace this with a hook in router
	beforeRouteEnter: (to, from, next) => {
		next(vm => {
			vm.$vuetify.goTo(0);
			vm.$store.dispatch("setLoading", false);
		});
	}
};
</script>
